import { render, staticRenderFns } from "./Experiencia.vue?vue&type=template&id=4b22ee3e&scoped=true&"
import script from "./Experiencia.vue?vue&type=script&lang=js&"
export * from "./Experiencia.vue?vue&type=script&lang=js&"
import style0 from "./Experiencia.vue?vue&type=style&index=0&id=4b22ee3e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b22ee3e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VChip,VCol,VContainer,VIcon,VRow,VSimpleTable})
